<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2 text-center">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
      <h4 class="mt-2">Mengautentikasi...</h4>
      <p>Mohon tunggu sementara kami menyiapkan sesi Anda.</p>
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import axios from 'axios'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BSpinner,
  },
  mounted() {
    this.processSSO()
  },
  methods: {
    processSSO() {
      const { nik, emp_id, empid_encrypt } = this.$route.query
      
      if (!nik && !emp_id) {
        alert('Data otentikasi tidak lengkap!')
        window.location.replace("http://app.dbc.co.id")
        return
      }

      let apiBase = process.env.VUE_APP_AXIOS_URL || '/'
      if (!apiBase.endsWith('/')) {
        apiBase += '/'
      }

      // Step 1: Authenticate via view_enkrip which sets the cookie internally
      axios({
        method: 'post',
        url: `${apiBase}api_mes/user-mes/view_enkrip`,
        params: {
          nik: nik,
          emp_id: emp_id,
          emp_id_enkrip: empid_encrypt,
          pass: "123456789", // From legacy login2.js
        },
      })
        .then(response => {
          if (!response.data.data || response.data.data.length === 0) {
            alert('NIK atau kredensial salah!')
            window.location.replace("http://app.dbc.co.id")
            return
          }

          const userData = response.data.data[0]

          if (!userData.nama || userData.nama === '') {
            alert('Anda Tidak Memiliki Akses ke Aplikasi MES!!!')
            window.location.replace("http://app.dbc.co.id")
            return
          }

          // Step 2: Get hak akses
          axios({
            method: 'post',
            url: `${apiBase}api_mes/hak-akses/view`,
            params: {
              emp_id: userData.id
            }
          })
            .then(response2 => {
              import('@/utils/session').then(({ setEncryptedSession }) => {
                const sessionData = {
                  menu: response2.data.data,
                  id: userData.id,
                  nik: userData.nik,
                  nama: userData.nama,
                  jabatan: userData.jabatan,
                  email: userData.email,
                  grade: userData.nm_grade,
                };
                
                setEncryptedSession(sessionData)
                window.localStorage.setItem('isLoggedIn', 'true')
                window.localStorage.setItem('accessToken', 'dummy_token_to_bypass_jwtService')
                
                useJwt.login({
                  email: 'admin@demo.com',
                  password: 'admin',
                })
                  .then(jwtResponse => {
                    const jwtUserData = jwtResponse.data.userData
                    useJwt.setToken(jwtResponse.data.accessToken)
                    useJwt.setRefreshToken(jwtResponse.data.refreshToken)
                    localStorage.setItem('userData', JSON.stringify(jwtUserData))
                    this.$ability.update(jwtUserData.ability)
                    
                    window.location.replace('/')
                  })
                  .catch(() => {
                    alert('Gagal autentikasi sistem.')
                    window.location.replace("http://app.dbc.co.id")
                  })
              });
            })
            .catch(() => {
              alert('Gagal mengambil hak akses.')
              window.location.replace("http://app.dbc.co.id")
            })
        })
        .catch(error => {
          alert('Anda Tidak Memiliki Akses ke Aplikasi MES!!!')
          window.location.replace("http://app.dbc.co.id")
        })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
